import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-publication-not-uploaded',
  templateUrl: './publication-not-uploaded.component.html',
  styleUrls: ['./publication-not-uploaded.component.scss']
})
export class PublicationNotUploadedComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) { }

  @Input() public type;
  @Input() public message;
  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }


}
